import * as PIXI from "pixi.js";

// Main layer holds all the elements that would go into actual app.
// Pan and Zoom events
export const mainLayer: PIXI.Container = new PIXI.Container();
mainLayer.interactiveChildren = false;

export const dragLayer: PIXI.Container = new PIXI.Container();
dragLayer.interactiveChildren = false;

export const lineLayer: PIXI.Container = new PIXI.Container();
lineLayer.interactiveChildren = false;
lineLayer.sortableChildren = true;

export const debugLayer: PIXI.Container = new PIXI.Container();
debugLayer.interactiveChildren = false;
